module.exports = __webpack_public_path__ + "media/images/landing/ar/create@2x-7ed85c358b61b7b8421834628f4c32d8.webp";